import bind from 'memoize-bind'

export default {
    data() {
        return {
            mediaScreenWidth: window.screen.width,
        }
    },

    computed: {
        isMobile() {
            return this.mediaScreenWidth < 768
        },

        isDesktop() {
            return !this.isMobile
        },
    },

    methods: {
        detectWidth() {
            this.mediaScreenWidth = getScreenWidth()
            this.$nextTick(() => this.mediaScreenWidth = getScreenWidth())
        }
    },

    mounted() {
        this.detectWidth()
        window.addEventListener('resize', bind(this.detectWidth, this))
    },

    beforeDestroy() {
        window.removeEventListener('resize', bind(this.detectWidth, this))
    },
}

function getScreenWidth() {
    return screen.width;
}